export default "/kiban/_next/static/images/09_2L_cupper_core_post-ba6298e6ef25f7d29697dca37f336cae.png";